export enum CashRegisterConnectionTypeEnum {
  CLOUD = "CLOUD",
  LOCAL = "LOCAL"
}

export const CashRegisterConnectionTypeEnumValues: string[] = [
  CashRegisterConnectionTypeEnum.CLOUD,
  CashRegisterConnectionTypeEnum.LOCAL
];
